<template>
  <div class="postavitev-info">
    <div class="info-okvir">
      <div class="postavitev-info-icone">
        <i class="fa fa-info-circle"></i>
      </div>
      <div class="postavitev-info-tekst">
        <p class="modra-barva-info">
          Sprememba dodatnih programskih paketov in programov začne veljati v roku 10 minut od časa
          spremembe.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'InfoKomponenta'
  }
</script>
<style scoped src="../../../../../../static/css/Naroci/NarociTelevizija/InfoKomponenta.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociTelevizija/InfoKomponenta.vue